if (!customElements.get('custom-related-products')) {
    customElements.define('custom-related-products', class CustomRelatedProducts extends HTMLElement {
        constructor() {
            super();
            this.swiperInstance = null;
            this.swiperEl = this.querySelector('.swiper-container');
            this.pagination = this.querySelector('.swiper-pagination');
        }

        connectedCallback() {
            if (!this.swiperEl) return;
            this.swiperInstance = new Swiper(this.swiperEl, {
                slidesPerView: 4,
                spaceBetween: 30,
                pagination: {
                    el: this.pagination,
                    clickable: true,
                },
                breakpoints: {
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    320: {

                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    }
                }
            })
        }
    });
}
